import { useMenus } from "./../utils/helper";
import "./../css/Sidebar.css";
import { useState } from "react";
import { MenuFetch, MenuView } from "./../utils/types";

function sortNested(data: any, outerConfig: any, innerConfig: any) {
  // sort outer array
  const sortedOuter = [...data].sort((a, b) => {
    const col = outerConfig.column;
    if (a[col] < b[col]) return outerConfig.direction === "asc" ? -1 : 1;
    if (a[col] > b[col]) return outerConfig.direction === "asc" ? 1 : -1;
    return 0;
  });

  // sort inner arrays
  return sortedOuter.map((obj) => ({
    ...obj,
    [innerConfig.array]: [...obj[innerConfig.array]].sort((a, b) => {
      const col = innerConfig.column;
      if (a[col] < b[col]) return innerConfig.direction === "asc" ? -1 : 1;
      if (a[col] > b[col]) return innerConfig.direction === "asc" ? 1 : -1;
      return 0;
    }),
  }));
}

export const Sidebar = () => {
  const outerConfig = { column: "name", direction: "asc" };
  const innerConfig = { array: "menuViews", column: "name", direction: "asc" };
  const menuGroups = sortNested(useMenus(), outerConfig, innerConfig);
  const [openGroups, setOpenGroups] = useState<{ [key: number]: boolean }>({});

  const toggleGroup = (index: number) => {
    setOpenGroups((prev) => ({ ...prev, [index]: !prev[index] }));
  };

  return (
    <div className="bg-sky-700/70 shadow-lg !w-52 px-2 py-6 m-2 !-mr-2 flex flex-col overflow-y-auto">
      <a
        href="/dashboard"
        className="font-bold text-xl mb-2 tracking-tight text-black"
      >
        Asset Register
      </a>
      {!!menuGroups &&
        menuGroups.map((group: MenuFetch, index) => (
          <div key={index} className="mb-2">
            <button
              className="w-full text-left font-semibold text-white py-2 px-2 bg-sky-700 rounded hover:bg-sky-800"
              onClick={() => toggleGroup(index)}
            >
              {group.name}
            </button>
            {openGroups[index] && (
              <div className="pl-2">
                {group.menuViews.map((menu: MenuView, index) => (
                  <a
                    href={menu.menuFunction}
                    className="menu-item block py-1 px-2 text-white hover:bg-sky-600 rounded"
                    key={index}
                  >
                    <span>{menu.name}</span>
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}
    </div>
  );
};
